import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Pages/App';
import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
//import getMuiTheme from '@material-ui/core/styles/getMuiTheme';
import { getMuiTheme } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles';
//import darkBaseTheme from '@material-ui/core/styles/baseThemes/darkBaseTheme';
import GridListTile from '@material-ui/core/GridListTile';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Provider } from 'react-redux';
import { store, history } from './store.js';
import { ConnectedRouter } from 'connected-react-router';

const theme = createMuiTheme({
  palette: {
    type: 'dark'
  }
});
ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />

        <App />
      </MuiThemeProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
//registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js